import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cc-simultaneous-calls',
  templateUrl: './simultaneous-calls.component.html',
  styleUrls: ['./simultaneous-calls.component.scss']
})
export class SimultaneousCallsComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
